import { useState } from 'react';

import { Paragraph2, SmallText } from 'inpock-ui-react';
import Flicking, { ChangedEvent } from '@egjs/react-flicking';

import { Rating } from '@/components/common';
import { thumbnail } from '@/utils';

import * as S from './styled';

interface ReviewImageModalProps {
  medias: { url: string }[];
  username: string;
  rating: number;
  onClose: () => void;
}

function ModalImage({ src }: { src: string }) {
  return (
    <S.ModalImage>
      <S.Image src={thumbnail.origin(src)} />;
    </S.ModalImage>
  );
}

export function ReviewImageModal({ medias, username, rating, onClose }: ReviewImageModalProps) {
  const [mediaIndex, setMediaIndex] = useState<number>(1);
  const flickingOptions = {
    defaultIndex: 0,
    panelsPerView: 1,
    threshhold: 11,
    align: 'center',
  };

  const updateIndex = (e: ChangedEvent<Flicking>) => {
    const { index } = e;
    setMediaIndex(index + 1);
  };

  return (
    <S.ReviewImageModal>
      <div className="close-btn" onClick={onClose} />
      <S.FlickingWrapper>
        <S.ModalImageIndex>
          <SmallText className="text-white">
            {mediaIndex}/{medias.length}
          </SmallText>
        </S.ModalImageIndex>
        <Flicking {...flickingOptions} onChanged={updateIndex}>
          {medias.map((media) => (
            <S.ImageWrapper className="image-wrapper">
              <ModalImage src={thumbnail.origin(media.url)} />
            </S.ImageWrapper>
          ))}
        </Flicking>
        <S.ReviewMeta>
          <Paragraph2 className="text-white">{username}</Paragraph2>
          <Rating rating={rating} size={18} />
        </S.ReviewMeta>
      </S.FlickingWrapper>
    </S.ReviewImageModal>
  );
}
